module.exports = __webpack_public_path__ + "static/media/home_bg.08e0f021.png";